/**
 * Sidemenu.vue Startup File
 *
 * @project Bitminds
 * @company Codendot <https://codendot.com>
 * @author Yahya Al Omar <yahya.a@codendot.com>
 * @since Wednesday, December 18, 2024 at 08:53 AM GMT+2
 *
 */

import { createApp } from "@/lib/app"
import AppComponent from "../apps/Sidemenu.vue"
import bootstrap from "../bootstrap/Sidemenu"

const app = createApp("sidemenu", AppComponent)
bootstrap(app)
app.mount()
